export type LeadWorkspace = 'interactions' | 'inquiries' | 'review' | 'history' | 'websites';

export function initialLeadWorkspace(search: string, canConsolidate: boolean): LeadWorkspace {
  if (!canConsolidate) return 'interactions';
  const params = new URLSearchParams(search);
  const selected = params.get('db_workspace');
  if (['interactions', 'inquiries', 'review', 'history', 'websites'].includes(selected || '')) return selected as LeadWorkspace;
  // Existing saved/filter links retain their interaction-table semantics.
  if (Array.from(params.keys()).some(key => key.startsWith('db_'))) return 'interactions';
  return 'inquiries';
}
